<template>
  <div class="wrapper">
    <naturalTxt v-if="num == 1"></naturalTxt>
    <UserProtocolTxt v-else></UserProtocolTxt>
    <van-button @click="iKnowBtnClick" class="btn" plain type="info" block round>我知道了</van-button>
  </div>
</template>

<script>
import NaturalTxt from "./naturalTxt.vue";
import UserProtocolTxt from "./userProtocolTxt";
export default {
  props: {
    protocolContent: {
      type: Number,
      default: 1
    }
  },
  computed: {
    num() {
      return this.protocolContent;
    }
  },
  components: {
    NaturalTxt,
    UserProtocolTxt
  },
  methods: {
    iKnowBtnClick() {
      this.$emit("iKnowBtnClick");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  padding: 10px 10px 18px;
  .btn {
    margin-top: 8px;
  }
}
</style>